import React from 'react'

import { Divider, DividerProps } from '@guiker/react-framework'

export const ListingScreenDivider: React.FC<Omit<DividerProps, 'color'>> = ({ ...props }) => (
  <Divider color={10} {...props} />
)
